import React, { FC, useMemo } from "react"
import { Button, Col, Form, Input, Row, Select } from "antd"
const { Option } = Select;

interface Props {
  filterBarOptions?: any[]
  submit?: () => void
  reset?: () => void
  form?: any
  showSearchButton?: boolean
  autoSearch?: boolean
}

const FilterBar: FC<Props> = ({
  filterBarOptions,
  submit,
  reset,
  form,
  showSearchButton = true,
  autoSearch = false,
}) => {
  const advanceSearchForm = useMemo(() => {
    if (!filterBarOptions) return null

    return (
      <Form
        form={form}
        layout="inline"
        style={{ maxWidth: 'none' }}
        onValuesChange={(changedValues, allValues) => {
          if (!!changedValues && autoSearch) {
            submit && submit()
          }
        }}
      >
        {filterBarOptions.map((item, index) => {
          switch (item.type) {
            case 'input':
              return (
                <Form.Item name={item.name} key={index} style={{ marginBottom: 0 }}>
                  <Input size="small" placeholder={`请输入${item.label}`} style={{ minWidth: 180 }} />
                </Form.Item>
              )
            case 'select':
              return (
                <Form.Item name={item.name} key={index} style={{ marginBottom: 0 }}>
                  <Select size="small" placeholder={`请选择${item.label}`} style={{ minWidth: 140 }}>
                    {item.options.map((option, optionIndex) => (
                      <Option value={option.value} key={optionIndex}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )
            default:
              return null
          }
        })}
        {showSearchButton && (
          <div className="space-x-2">
          <Button
            type="primary"
            onClick={submit}
            size="small"
          >
            <span className="text-xs text-white">搜索</span>
          </Button>
          <Button
            onClick={reset}
            size="small"
          >
            <span className="text-xs">清除搜索</span>
          </Button>
          </div>
        )}
      </Form>
    )
  }, [filterBarOptions, form, submit, reset, showSearchButton, autoSearch])

  return advanceSearchForm
}

export default FilterBar
